// TIP-488 (MV Stage 2) — the ONE reusable "Become a Member" page, mounted at a
// stable route (/membership/:companyId). Wraps PaymentScreen (the existing
// Stripe Embedded Checkout UI, reframed Verified → Membership) so profile CTAs,
// the dashboard, and the post-verify step can all route here.
import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import PaymentScreen from "../../components/public/VerifyAccount/PaymentScreen";

const Membership = () => {
  const { companyId } = useParams();
  const navigate = useNavigate();
  // No lead/token here — PaymentScreen runs the direct company_id checkout path.
  // "Skip" simply returns to the dashboard (this isn't the gated verify flow).
  return <PaymentScreen companyId={companyId} onSkip={() => navigate("/dashboard")} />;
};

export default Membership;
